import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [email,   setEmail]   = useState(params.get("email") || "");
  const [token,   setToken]   = useState("");
  const [newPw,   setNewPw]   = useState("");
  const [confPw,  setConfPw]  = useState("");
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPw !== confPw) { setError("Passwords do not match."); return; }
    setLoading(true);
    try {
      const res  = await fetch(`${API}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, token, new_password: newPw }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <h1>R I R A</h1>
          <p>Review Intelligence Response Assistant</p>
        </div>

        {success ? (
          <div className="forgot-result">
            <div className="forgot-result-title">Password reset</div>
            <p className="forgot-result-note">Your password has been updated. You can now sign in with your new password.</p>
            <button className="auth-submit" style={{ marginTop: 20 }} onClick={() => navigate("/auth")}>
              Sign In
            </button>
          </div>
        ) : (
          <>
            <div className="auth-section-title">Set a new password</div>
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-field">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="auth-field">
                <label>Reset code</label>
                <input
                  type="text"
                  placeholder="e.g. A3F9B2"
                  value={token}
                  onChange={(e) => setToken(e.target.value.toUpperCase())}
                  maxLength={6}
                  required
                  autoFocus
                />
              </div>
              <div className="auth-field">
                <label>New password</label>
                <input
                  type="password"
                  placeholder="••••••••"
                  value={newPw}
                  onChange={(e) => setNewPw(e.target.value)}
                  minLength={6}
                  required
                />
              </div>
              <div className="auth-field">
                <label>Confirm new password</label>
                <input
                  type="password"
                  placeholder="••••••••"
                  value={confPw}
                  onChange={(e) => setConfPw(e.target.value)}
                  required
                />
              </div>
              {error && <div className="auth-error">{error}</div>}
              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? <span className="auth-spinner" /> : "Reset Password"}
              </button>
            </form>
            <p className="auth-note" style={{ marginTop: 16 }}>
              <button className="auth-link-btn" onClick={() => navigate("/auth")}>Back to Sign In</button>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
